/** Múltiplas notas fiscais / comprovantes por transação financeira */

export type NotaFiscalAnexo = {
  url: string;
  nome: string;
};

export function parseNotasFiscais(transacao: {
  notas_fiscais?: unknown;
  nota_fiscal_url?: string | null;
  nota_fiscal_name?: string | null;
}): NotaFiscalAnexo[] {
  if (Array.isArray(transacao.notas_fiscais)) {
    const fromColumn = transacao.notas_fiscais
      .map((item) => {
        if (!item || typeof item !== "object") return null;
        const o = item as Record<string, unknown>;
        const url = String(o.url ?? "").trim();
        const nome = String(o.nome ?? "").trim();
        if (!url) return null;
        return { url, nome: nome || "Nota fiscal" };
      })
      .filter((x): x is NotaFiscalAnexo => x != null);
    if (fromColumn.length > 0) return fromColumn;
  }

  if (transacao.nota_fiscal_url?.trim()) {
    return [
      {
        url: transacao.nota_fiscal_url.trim(),
        nome: transacao.nota_fiscal_name?.trim() || "Nota fiscal",
      },
    ];
  }

  return [];
}

export function temNotaFiscal(transacao: {
  notas_fiscais?: unknown;
  nota_fiscal_url?: string | null;
}): boolean {
  return parseNotasFiscais(transacao).length > 0;
}

export function syncLegacyNotaFiscalFields(notas: NotaFiscalAnexo[]) {
  const primeira = notas[0];
  return {
    notas_fiscais: notas,
    nota_fiscal_url: primeira?.url ?? null,
    nota_fiscal_name: primeira?.nome ?? null,
  };
}

export function isNotasFiscaisColumnMissing(error: unknown): boolean {
  const e = error as { code?: string; message?: string };
  return e?.code === "PGRST204" && (e.message?.includes("notas_fiscais") ?? false);
}
